export const COURT = {
  halfLength: 15,
  halfWidth: 8.6,
  boardHeight: 1.05,
  wallThickness: 0.3,
} as const;

export const GOAL = {
  halfWidth: 2.3,
  height: 2.3,
  depth: 1.15,
  postRadius: 0.065,
} as const;

export const GOALKEEPER_AREA = {
  depth: 4,
  halfWidth: GOAL.halfWidth + 1.25,
} as const;

export const BALL = {
  radius: 0.22,
  maxSpeed: 34,
  groundFriction: 0.55,
} as const;

export const PLAYER = {
  radius: 0.42,
  runSpeed: 7.1,
  sprintSpeed: 9.6,
  tiredFactor: 0.52,
  acceleration: 30,
  turnRate: 10,
  controlRadius: 0.95,
  touchRadius: 0.62,
  shotMinSpeed: 14.5,
  shotMaxSpeed: 29.5,
  chargeTime: 0.35,
  passSpeed: 15,
  slideSpeed: 14.5,
  slideDuration: 0.42,
  slideRecovery: 0.7,
  slideCooldown: 1.3,
  slideDamage: 28,
  slideKnockdown: 1.6,
  punchCooldown: 0.5,
  punchRange: 1.42,
  punchDamage: 16,
  punchStun: 0.42,
  punchKnockback: 11,
  maxStamina: 100,
  maxHp: 100,
  hpRegenPerSecond: 2,
  hpRegenDelay: 4,
  hpOnHit: 8,
  knockoutDuration: 5,
  reviveHp: 60,
  stumbleHp: 35,
  sprintDrain: 17,
  staminaRegen: 11,
  hitStaminaScale: 1,
  downDuration: 2.3,
  getupDuration: 0.55,
  reviveStamina: 55,
} as const;

export const ITEMS = {
  boxRespawn: 19,
  maxBoxes: 2,
  hammerDuration: 8,
  hammerDamage: 38,
  hammerRange: 1.75,
  hammerKnockback: 18,
  magnetDuration: 8,
  magnetRadius: 3.6,
  bombFuse: 1.15,
  bombRadius: 3.1,
  bombDamage: 30,
  bombKnockdown: 1.9,
} as const;

export const MATCH = {
  duration: 180,
  kickoffCountdown: 3,
  goalCelebration: 3.4,
  goldenDurationCap: 240,
} as const;

export const SCORING = {
  goalTrauma: 0.85,
  bombTrauma: 0.8,
  tackleTrauma: 0.6,
  punchTrauma: 0.55,
  postTrauma: 0.3,
  kickTrauma: 0.14,
  wallTrauma: 0.1,
  hitstopTackle: 105,
  hitstopBomb: 95,
  hitstopGoal: 0,
} as const;

export const FORMATIONS = {
  kickoffA: [
    { role: 'gk', x: -14.1, z: 0 },
    { role: 'field', x: -4.2, z: -2.6 },
    { role: 'field', x: -2.4, z: 2.4 },
  ],
  kickoffB: [
    { role: 'gk', x: 14.1, z: 0 },
    { role: 'field', x: 4.2, z: 2.6 },
    { role: 'field', x: 2.4, z: -2.4 },
  ],
} as const;

export const CAMERA = {
  baseFov: 46,
  portraitFov: 55,
  height: 9.6,
  distance: 15.6,
  portraitHeight: 13.2,
  portraitDistance: 20.5,
  lag: 0.24,
  leadScale: 0.72,
} as const;

export const QUALITY = {
  shadowMapSize: 2048,
  mobileShadowMapSize: 1024,
  maxDpr: 2,
  mobileMaxDpr: 1.75,
} as const;
